







































import {ResponseToActivityRequestsResponse, WaitingActivityRequests} from '@/models';
import { Actions } from '@/store';
import { ToastsService, buildGeekName } from '@/utils';
import Vue from 'vue';

export default Vue.extend({
  name: 'RejectActivityRequestModal',
  props: {
    activityWaitingRequest: Object as () => WaitingActivityRequests,
  },
  data() {
    return {
      reason: '',
      loader: {
        isRequestPending: false,
      },
    };
  },
  methods: {
    async rejectActivityRequest() {
      this.loader.isRequestPending = true;
      try {
        await this.$store.dispatch(
          Actions.activities.rejectWaitingActivityRequest,
          {
            id: this.activityWaitingRequest.id,
            reason: this.reason,
          } as ResponseToActivityRequestsResponse,
        );
        ToastsService.success(this.$t('admin-panel.activities.tabs.waiting-requests.activity-rejected-toast',
        {geekName: buildGeekName(this.activityWaitingRequest.geek)}) as string);
        this.$bvModal.hide('reject-activity-modal');
        this.$emit('refresh');
      } finally {
        this.loader.isRequestPending = false;
      }
    },
  },
});
